import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelMedium } from 'baseui/typography';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import {
  currentStatesPoweredOffState,
  currentStatesPoweredOnState,
  filteredCurrentStateIdsState,
} from '../../storage/currentStates';
import ShareAssetsButton from '../shared/ShareAssetsButton';
import { StyledTooltip } from '../ui/StyledTooltip';

function CurrentStatesInfo() {
  const { css, theme } = useStyles();
  const total = useRecoilValue(filteredCurrentStateIdsState)?.length || 0;
  const poweredOn = useRecoilValue(currentStatesPoweredOnState);
  const poweredOff = useRecoilValue(currentStatesPoweredOffState);

  return (
    <FlexRow
      centered
      classNames={css({
        background: theme.colors.backgroundSecondary,
        padding: `5px ${theme.sizing.scale300}`,
        borderRadius: theme.sizing.scale300,
      })}
    >
      <FlexRow
        centered
        gap={theme.sizing.scale100}
      >
        <ShareAssetsButton />
        <LabelMedium>
          {total} {total === 1 ? 'unidad' : 'unidades'}
        </LabelMedium>
      </FlexRow>
      <StyledTooltip
        content={poweredOn === 1 ? 'Encendido' : 'Encendidos'}
        showArrow={false}
      >
        <FlexRow
          centered
          gap={theme.sizing.scale0}
        >
          <MaterialIcon
            name="power_settings_new"
            size="compact"
            success
          />
          <LabelMedium>{poweredOn}</LabelMedium>
        </FlexRow>
      </StyledTooltip>
      <StyledTooltip
        content={poweredOff === 1 ? 'Apagado' : 'Apagados'}
        showArrow={false}
      >
        <FlexRow
          centered
          gap={theme.sizing.scale0}
        >
          <MaterialIcon
            name="power_settings_new"
            size="compact"
            warn
          />
          <LabelMedium>{poweredOff}</LabelMedium>
        </FlexRow>
      </StyledTooltip>
    </FlexRow>
  );
}

export default memo(CurrentStatesInfo);
